export enum MountingCardViewOptions {
  Card = 'card',
  List = 'list'
}
